export const tickerItems = [
  "当红男团巡演门票十秒售罄，二手票价一夜翻五倍",
  "国产单机新作上线首日，同时在线玩家突破两百万",
  "连锁咖啡推早餐季，网友为“价格”与“口味”吵翻天",
  "周末城市漫步继续走热，街区小店集体被排到巷口",
  "热梗“已读乱回”刷屏，你的聊天记录中招了吗",
  "当红直播综艺现场连麦翻车，主播情绪当场破防",
];

export interface CategoryMeta {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: string;
}

export const categories: CategoryMeta[] = [
  { id: "wenyu", name: "文娱圈", desc: "演唱会、综艺、剧集、艺人人气，追更不迷路", icon: "ri-music-2-fill", count: "1.2w+" },
  { id: "tech", name: "科技风", desc: "新机、游戏、大模型，前沿话题第一时间围观", icon: "ri-cpu-line", count: "8.6k+" },
  { id: "business", name: "商业局", desc: "品牌动作、价格战、行业风向，看得懂的门道", icon: "ri-store-2-fill", count: "6.4k+" },
  { id: "social", name: "社会说", desc: "身边事与趋势观察，人人都在聊的现实议题", icon: "ri-earth-fill", count: "9.1k+" },
  { id: "sports", name: "体坛热", desc: "赛事、转会、神操作，属于体育迷的实时现场", icon: "ri-trophy-fill", count: "5.2k+" },
  { id: "meme", name: "网络梗", desc: "流行语与热梗考古，冲浪必须懂的暗号", icon: "ri-chat-smile-3-fill", count: "1.5w+" },
];

export interface HotTopic {
  id: string;
  title: string;
  categoryId: string;
  heat: number;
  views: string;
  tag: string;
  up: boolean;
}

export const hotTopics: HotTopic[] = [
  { id: "hot1", title: "当红男团巡演门票十秒售罄，二手票溢价翻五倍", categoryId: "wenyu", heat: 98, views: "326w", tag: "爆", up: true },
  { id: "hot2", title: "国产单机新作上线首日，同时在线玩家突破两百万", categoryId: "tech", heat: 94, views: "281w", tag: "爆", up: true },
  { id: "hot3", title: "连锁咖啡推“9.9 早餐季”，网友为价格与口味吵翻天", categoryId: "business", heat: 87, views: "198w", tag: "热", up: true },
  { id: "hot4", title: "年轻人流行周末城市漫步，街区小店集体排到巷口", categoryId: "social", heat: 82, views: "156w", tag: "热", up: true },
  { id: "hot5", title: "热梗“已读乱回”一夜刷屏，你中招了吗", categoryId: "meme", heat: 76, views: "143w", tag: "新", up: true },
  { id: "hot6", title: "足球转会窗口收尾，中场新援官宣引爆评论区", categoryId: "sports", heat: 71, views: "109w", tag: "热", up: false },
];

export interface FeedItem {
  id: string;
  categoryId: string;
  time: string;
  live: boolean;
  title: string;
  summary: string;
  watch: string;
  comments: string;
  heat: number;
  tags: string[];
}

export const feedCategories = [
  { id: "all", name: "全部现场" },
  { id: "wenyu", name: "文娱圈" },
  { id: "tech", name: "科技风" },
  { id: "business", name: "商业局" },
  { id: "social", name: "社会说" },
  { id: "sports", name: "体坛热" },
  { id: "meme", name: "网络梗" },
];

export const feedItems: FeedItem[] = [
  { id: "f1", categoryId: "wenyu", time: "2 分钟前", live: true, title: "巡演官宣加开三场，票务平台仍被挤到卡顿", summary: "在首轮门票秒空后，主办方宣布同城加开三场。粉丝一边刷开票页面一边讨论档期，黄牛代拍群同步涨价，实名制能否拦住转卖成为最大悬念。", watch: "12.4w", comments: "8300", heat: 95, tags: ["加场", "实名购票", "黄牛"] },
  { id: "f2", categoryId: "tech", time: "8 分钟前", live: true, title: "新游上线首日服务器扩容，开发商紧急回应排队", summary: "因同时在线人数远超预期，部分大区出现排队与短暂回档。官方发布补偿公告并连夜扩容，玩家一边吐槽一边接着冲，口碑与热度同步走高。", watch: "9.8w", comments: "6200", heat: 91, tags: ["服务器", "补偿公告", "首发"] },
  { id: "f3", categoryId: "business", time: "15 分钟前", live: false, title: "早餐季套餐实测：分量缩水引争议，官方晒后厨自证", summary: "有消费者晒出对比图称套餐分量变少，相关连锁回应称杯型未变并晒出出餐标准。网友分成“成分派”与“价格派”两派，讨论仍在发酵。", watch: "6.1w", comments: "3900", heat: 78, tags: ["套餐实测", "争议回应"] },
  { id: "f4", categoryId: "social", time: "26 分钟前", live: false, title: "城市漫步出圈：书店+咖啡街区成周末新晋打卡地", summary: "一条以二手书店和社区咖啡串联的老街区，凭松弛感刷屏社交平台。沿街小店延长营业时间，商家坦言客流翻倍，却也开始担心“打卡焦虑”。", watch: "5.4w", comments: "2100", heat: 74, tags: ["城市漫步", "老街区"] },
  { id: "f5", categoryId: "meme", time: "34 分钟前", live: true, title: "“已读乱回”登顶热词：不接梗都接不住朋友的梗", summary: "一句“已读乱回”让无数人笑着翻出聊天记录。语言学者提醒，网络热梗迭代加速的背后，是年轻群体对“交流新玩法”的集体共创。", watch: "11.2w", comments: "9800", heat: 88, tags: ["热词", "网络流行语"] },
  { id: "f6", categoryId: "sports", time: "42 分钟前", live: false, title: "中场新援官宣，主队球迷连夜排起“欢迎横幅”", summary: "转会窗临近收尾，一支联赛劲旅官宣签下当红中场。社交媒体瞬间刷屏，球衣号码未定先被抢光，评论区“下一个是谁”的猜测不断。", watch: "4.2w", comments: "1800", heat: 69, tags: ["转会", "官宣"] },
  { id: "f7", categoryId: "business", time: "1 小时前", live: false, title: "国产新能源品牌隔空“比价”，新一轮价格战打响", summary: "两家品牌一前一后官宣限时降价并互呛“配置透明”。行业观察认为，这轮比的不只是价格，更是供应链与渠道的贴身肉搏。", watch: "7.7w", comments: "4100", heat: 80, tags: ["新能源", "价格战"] },
  { id: "f8", categoryId: "wenyu", time: "1 小时前", live: false, title: "国民级剧集导演官宣新项目，选角名单全网猜测", summary: "导演一句“正在筹备”点燃讨论区，从主演到配角都被网友“预排”。官方尚未回应，围观群众已经替剧组写好了十条支线。", watch: "8.9w", comments: "5600", heat: 84, tags: ["剧集", "选角"] },
];

export interface FeatureStory {
  id: string;
  categoryId: string;
  category: string;
  title: string;
  excerpt: string;
  readMin: string;
  date: string;
  image: string;
  tags: string[];
}

export const featuredStories: FeatureStory[] = [
  {
    id: "s1",
    categoryId: "wenyu",
    category: "文娱圈",
    title: "复盘一场票务风波：秒空、溢价与黄牛，都卡在同一个环节",
    excerpt: "从开票到二手价翻五倍，我们循着票务链路拆解：放票比例、退改规则、转卖平台与实名核验之间，到底哪里漏了风。",
    readMin: "9 分钟",
    date: "09-07",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20concert%20scene%20with%20crowd%20holding%20up%20glowing%20lightsticks%20on%20a%20dark%20stage%2C%20vermillion%20and%20cream%20magazine%20print%20aesthetic%2C%20moody%20spotlight%2C%20high%20detail%2C%20cinematic%20atmosphere&width=800&height=560&seq=story-01&orientation=landscape",
    tags: ["票务复盘", "行业拆解"],
  },
  {
    id: "s2",
    categoryId: "tech",
    category: "科技风",
    title: "国产游戏出海这一年：谁在闷声发大财",
    excerpt: "从美术外包到自研买断，我们盘点了头部厂商的海外打法、玩家口碑与“文化出圈”的细节，看增量到底从哪来。",
    readMin: "12 分钟",
    date: "09-06",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20isometric%20game%20console%20and%20controller%20composition%20with%20glowing%20screen%2C%20cream%20and%20vermillion%20backdrop%2C%20soft%20amber%20lighting%2C%20magazine%20print%20aesthetic%2C%20high%20detail&width=800&height=560&seq=story-02&orientation=landscape",
    tags: ["游戏出海", "行业观察"],
  },
  {
    id: "s3",
    categoryId: "social",
    category: "社会说",
    title: "热搜之外：城市漫步经济是如何悄悄长大的",
    excerpt: "一条街道、几家小店、几把露天椅子，怎么就装下了年轻人的松弛感？我们走进街区，看“打卡”之外真实的小生意。",
    readMin: "7 分钟",
    date: "09-05",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20street%20scene%20of%20young%20people%20strolling%20past%20a%20brick%20neighborhood%20with%20small%20cafes%20and%20bookstores%2C%20cream%20and%20amber%20palette%2C%20magazine%20print%20aesthetic%2C%20high%20detail&width=800&height=560&seq=story-03&orientation=landscape",
    tags: ["城市漫步", "街区经济"],
  },
  {
    id: "s4",
    categoryId: "meme",
    category: "网络梗",
    title: "从“吃瓜”到“已读乱回”：网络流行语迭代二十年",
    excerpt: "我们顺着几条热梗回溯它们的出生地、传播链与生命周期，看看语言到底在替这届年轻人表达什么。",
    readMin: "10 分钟",
    date: "09-04",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20lay%20of%20smartphones%20keyboards%20and%20chat%20bubble%20paper%20cutouts%20on%20cream%20paper%2C%20vermillion%20and%20amber%20accents%2C%20magazine%20print%20aesthetic%2C%20high%20detail&width=800&height=560&seq=story-04&orientation=landscape",
    tags: ["流行语", "语言观察"],
  },
];

export interface Discussion {
  id: string;
  name: string;
  avatar: string;
  tone: string;
  text: string;
  time: string;
  replies: string;
  likes: number;
}

export const discussions: Discussion[] = [
  { id: "d1", name: "前排小马扎", avatar: "马", tone: "bg-primary-500", text: "实名制真能拦住黄牛吗？我觉得关键在转卖平台放行比例，你们怎么看？", time: "刚刚", replies: "128", likes: 2100 },
  { id: "d2", name: "电波少年", avatar: "电", tone: "bg-accent-600", text: "新游排队排到怀疑人生，但补偿发得还算大方，真香警告。", time: "5 分钟前", replies: "96", likes: 1400 },
  { id: "d3", name: "楼下一杯美式", avatar: "美", tone: "bg-secondary-600", text: "早餐季我实测过三款，分量差异其实不大，网上吵的更多是情绪。", time: "12 分钟前", replies: "64", likes: 902 },
  { id: "d4", name: "不吃香菜", avatar: "香", tone: "bg-primary-400", text: "城市漫步逛的就是那份松弛，别把它又卷成打卡 KPI 就行。", time: "18 分钟前", replies: "43", likes: 715 },
];

export interface PollOption {
  id: string;
  label: string;
  count: number;
}

export const poll = {
  question: "今晚这一波瓜，你最想前排围观哪一类？",
  options: [
    { id: "p1", label: "文娱圈的新鲜事", count: 3820 },
    { id: "p2", label: "科技与游戏动态", count: 2960 },
    { id: "p3", label: "商业与价格战", count: 2130 },
    { id: "p4", label: "社会与生活方式", count: 1870 },
  ] as PollOption[],
  voted: 12480,
};

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "宿野吃瓜是什么？", a: "宿野吃瓜是一个聚焦全网热点事件实时围观与讨论的社区，把分散在社交媒体、资讯平台上的热议话题与进展时间线集中呈现，方便大家前排看热闹、随时了解来龙去脉。" },
  { q: "内容的更新频率如何？", a: "热点事件出现后，宿野会尽量在短时间内把首发信息与各方回应同步呈现，并持续刷新进展时间线，力求不错过关键节点。" },
  { q: "如何保证信息真实可靠？", a: "我们优先聚合已经公开、可被检索核对的信源，并标注出处与时间线；对存在争议的信息会明确提示来源方，避免只呈现单方说法。" },
  { q: "会传播未经核实的小道消息吗？", a: "不会。宿野以公开可核实的信息为主，对传闻会标注“尚未证实”，不替未经核实的单方爆料背书，也不放大情绪化表达。" },
  { q: "如何参与围观与讨论？", a: "你可以在现场围观区查看进展、在围观广场发表看法、参与热门投票，并在评论区留下你的态度。" },
  { q: "可以投稿或提供事件线索吗？", a: "欢迎在页脚联系我们：可发送邮件或在留言区留下线索，编辑部核实后会优先整理成专题发布。" },
];

export const editorialPrinciples = [
  { icon: "ri-scales-3-line", title: "信源优先", desc: "只聚合公开、可检索、可对证的公开信息，标注出处。" },
  { icon: "ri-time-line", title: "时间线还原", desc: "用清晰时间轴梳理进展，帮你看清事情发展的先后。" },
  { icon: "ri-eye-off-line", title: "不散播单方爆料", desc: "传闻标注“尚未证实”，不替情绪与立场站台。" },
  { icon: "ri-quill-pen-line", title: "克制表达", desc: "不放大对立、不标题党，把讨论的尺子还给读者。" },
];